import { axios } from '@/libs/api.request';
import { Response } from '@/types/request.d';

interface TagListParams {
    tag_id?: string; // 默认0，则获取一级标签列表
    tag_name?: string;
}
export interface TagItem {
    id: string;
    sys_user_id: string;
    project_id: string;
    tag_id: string;
    tag_name: string;
    has_child: '1' | '0'; // 是否有子标签 1是 0否
}
interface TagListRes {
    list: TagItem[];
    page: string;
    page_size: string;
}
/**
 * 获取标签列表
 */
export const getTagList = (params: TagListParams) => axios.request<Response<TagListRes>>({
    url: '/chat/chat-session-tag/get-tag-list',
    method: 'get',
    params,
    // mock: true,
});

interface AddTagParams {
    tag_id?: string; // 一级标签可不传
    tag_name: string;
}
export interface AddTagItem {
    created_time: string;
    first_tag_id: string;
    id: string;
    level: string;
    project_id: string;
    sys_user_id: string;
    tag_id: string;
    tag_name: string;
    updated_time: string;
    creator_name: string;
}
interface AddTagRes{
    res: string;
    data: AddTagItem;
}
/**
 * 添加会话标签
 */
export const addTag = (params: AddTagParams) => axios.request<Response<AddTagRes>>({
    url: '/chat/chat-session-tag/add-tag',
    method: 'post',
    data: params,
    customTips: true,
    // mock: true,
});

interface UpdateTagParams {
    tag_id: string;
    tag_name: string;
}
interface UpdateTagRes {
    res: string;
}
/**
 * 修改会话标签
 */
export const updateTag = (params: UpdateTagParams) => axios.request<Response<UpdateTagRes>>({
    url: '/chat/chat-session-tag/update-tag',
    method: 'post',
    data: params,
    // mock: true,
});

interface DelTagParams {
    tag_id: string;
}
/**
 * 删除会话标签
 */
export const delTag = (params: DelTagParams) => axios.request({
    url: '/chat/chat-session-tag/del-tag',
    method: 'post',
    data: params,
    // mock: true,
});

/**
 * 会话标签列表搜索平铺效果
 */
export const searchTagList = (params: TagListParams) => axios.request<Response<any>>({
    url: '/chat/chat-session-tag/search-tag-list',
    method: 'get',
    params,
    cancelDuplicateRequest: true,
    // mock: true,
});

/**
 * 会话标签列表搜索
 */
export const searchTag = (params: TagListParams) => axios.request<Response<any>>({
    url: '/chat/chat-session-tag/search-tag',
    method: 'get',
    params,
    cancelDuplicateRequest: true,
    // mock: true,
});
